import request from '@/utils/request'

/**
 * 我的奖励首页
 * @param contact
 */
export function getRewards(contact) {
  return request({
    url: '/idea/getStatistics',
    method: 'post',
    data: {
      contact: contact
    }
  })
}

/**
 * 收入明细列表
 * @param contact
 */
export function getIncomeList(contact) {
  return request({
    url: '/idea/getBillList',
    method: 'post',
    data: {
      contact: contact
    }
  })
}

/**
 * 收入明细详情
 * @param orderId
 */
export function getIncomeDetail(orderId) {
  return request({
    url: '/idea/getBillDetail',
    method: 'post',
    data: {
      order_no: orderId
    }
  })
}

/**
 * 获取支付宝账号
 * @param contact
 */
export function getPayAccount(contact) {
  return request({
    url: '/idea/getPayAccount',
    method: 'post',
    params: {
      contact: contact
    },
    data: {
      contact: contact
    }
  })
}

/**
 * 绑定支付宝账号
 * @param data
 */
export function bindPayAccount(data) {
  return request({
    url: '/idea/bindPayAccount',
    method: 'post',
    params: {
      contact: data.contact,
      pay_account: data.pay_account,
      name: data.name
    },
    data
  })
}

/**
 * 提现
 * @param data
 */
export function cashOut(data) {
  return request({
    url: '/idea/cashOut',
    method: 'post',
    params: {
      amount: data.amount,
      contact: data.contact,
      pay_account: data.pay_account,
      verifycode: data.verifycode
    },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/me.js